import { Grid, styled } from '@mui/material';

export const GridStyled = styled(Grid)(() => ({
  display: 'flex',
})) as typeof Grid;
